/**
 * Форма русского существительного при числе: подпись согласуется со стоящим
 * перед ней количеством. Один и тот же выбор формы во всех подписях, чтобы
 * склонение не переписывалось заново на каждом экране.
 */
export interface RussianNounForms {
  /** Форма при количестве, оканчивающемся на 1 (кроме 11): «1 элемент». */
  one: string;
  /** Форма при количестве, оканчивающемся на 2—4 (кроме 12—14): «2 элемента». */
  few: string;
  /** Форма при остальных количествах, включая 11—14 и 0: «5 элементов». */
  many: string;
}

export function pluralizeRussian(count: number, forms: RussianNounForms): string {
  let form: string;
  const lastTwo = count % 100;
  const lastOne = count % 10;
  if (lastTwo >= 11 && lastTwo <= 14) {
    form = forms.many;
  } else if (lastOne === 1) {
    form = forms.one;
  } else if (lastOne >= 2 && lastOne <= 4) {
    form = forms.few;
  } else {
    form = forms.many;
  }
  return form;
}
